<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      top
      v-bind:flip="flip"
      v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <svg
            v-if="!isDeleted"
            class="tooth-down-5 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x="24.297" y="109.333" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M47.495 126.424H26.663l4.836 55.777h11.904l4.093-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 22.631 127.373)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M24 131.082a1.68 1.68 0 0 1 1.939-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032A1.68 1.68 0 0 1 24 131.082Zm2.433 5.266.17.02 22.177 3.696a1.68 1.68 0 0 1-.553 3.314l-22.176-3.695-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.56 3.313l-21.842-3.696-.167-.037a1.68 1.68 0 0 1 .557-3.296Zm-.758 7.729a1.68 1.68 0 0 1 1.928-1.387l20.497 3.36a1.68 1.68 0 1 1-.544 3.316L27.4 152.331a1.679 1.679 0 0 1-1.386-1.928Zm2.141 4.924.171.024 19.152 3.696a1.68 1.68 0 0 1-.636 3.299l-19.153-3.697-.167-.04a1.68 1.68 0 0 1 .634-3.282Zm.671 5.988.17.024 17.472 3.361.168.04a1.681 1.681 0 0 1-.802 3.259l-17.472-3.36-.167-.04a1.681 1.681 0 0 1 .631-3.284Zm.294 6.658.171.02 16.129 2.688a1.68 1.68 0 0 1-.553 3.314l-16.128-2.687-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.39 6.33.171.025 15.12 3.024.167.041a1.682 1.682 0 0 1-.827 3.253l-15.12-3.024-.166-.041a1.682 1.682 0 0 1 .655-3.278Z" />
            </g>
            <g v-else>
              <path
                d="M24.7556 132.5C24.3397 130.59 25.1306 116.927 24.7557 111.149L48.1341 111.357C47.4409 120.455 44.3322 139.711 43.5002 148.512C42.4603 159.513 41.996 174.367 39.5003 178C37.0045 181.632 32.533 182.047 33.5729 174.99C34.6128 167.932 27.9162 152.352 27.5002 148.512C27.0843 144.672 25.2755 134.887 24.7556 132.5Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M40.4307 127.826L40.4506 127.878C40.5887 128.239 40.6186 128.631 40.5398 129.009C38.0569 140.933 37.6686 155.866 37.0847 159.589C37.032 159.925 36.8529 160.215 36.6005 160.443C36.3495 160.669 35.9963 160.814 35.7273 160.609C35.4763 160.418 35.2213 160.03 35.2213 159.24C35.2213 148.202 35.0786 134.909 33.9493 128.673L33.8387 128.011C33.7846 127.688 33.8649 127.356 34.0611 127.093C34.2212 126.879 34.4481 126.724 34.7061 126.653L35.0915 126.546L35.9963 126.466L37.8338 126.513L38.9153 126.679C39.0449 126.699 39.1728 126.729 39.2981 126.767C39.8185 126.927 40.2363 127.318 40.4307 127.826Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M46.9903 90.1846C42.9971 86.0332 38.2551 84.9262 36.3833 84.8916C29.6448 86.6352 24.4245 92.6063 22.6567 95.3739C22.0261 98.2807 21.7389 104.983 24.7556 111.149C25.2215 112.101 25.7661 113.041 26.4003 113.951C31.1422 120.76 37.3886 119.902 39.919 118.622C41.4095 117.722 45.1392 115.01 48.1341 111.357C51.129 107.704 51.3925 102.154 51.1498 99.8366C51.0458 98.2799 50.9835 94.336 46.9903 90.1846Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-down-5 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g id="implant">
              <rect width="25.564" height="13.231" x="24.297" y="109.333" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M47.495 126.424H26.663l4.836 55.777h11.904l4.093-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 22.631 127.373)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M24 131.082a1.68 1.68 0 0 1 1.939-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032A1.68 1.68 0 0 1 24 131.082Zm2.433 5.266.17.02 22.177 3.696a1.68 1.68 0 0 1-.553 3.314l-22.176-3.695-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.56 3.313l-21.842-3.696-.167-.037a1.68 1.68 0 0 1 .557-3.296Zm-.758 7.729a1.68 1.68 0 0 1 1.928-1.387l20.497 3.36a1.68 1.68 0 1 1-.544 3.316L27.4 152.331a1.679 1.679 0 0 1-1.386-1.928Zm2.141 4.924.171.024 19.152 3.696a1.68 1.68 0 0 1-.636 3.299l-19.153-3.697-.167-.04a1.68 1.68 0 0 1 .634-3.282Zm.671 5.988.17.024 17.472 3.361.168.04a1.681 1.681 0 0 1-.802 3.259l-17.472-3.36-.167-.04a1.681 1.681 0 0 1 .631-3.284Zm.294 6.658.171.02 16.129 2.688a1.68 1.68 0 0 1-.553 3.314l-16.128-2.687-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.39 6.33.171.025 15.12 3.024.167.041a1.682 1.682 0 0 1-.827 3.253l-15.12-3.024-.166-.041a1.682 1.682 0 0 1 .655-3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M46.9903 90.1846C42.9971 86.0332 38.2551 84.9262 36.3833 84.8916C29.6448 86.6352 24.4245 92.6063 22.6567 95.3739C22.0261 98.2807 21.7389 104.983 24.7556 111.149C25.2215 112.101 25.7661 113.041 26.4003 113.951C31.1422 120.76 37.3886 119.902 39.919 118.622C41.4095 117.722 45.1392 115.01 48.1341 111.357C51.129 107.704 51.3925 102.154 51.1498 99.8366C51.0458 98.2799 50.9835 94.336 46.9903 90.1846Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ [round]: isMilky, selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ [round]: isMilky, selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <bottom-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import BottomToothSurface from '../BottomToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    BottomToothSurface,
  },
  computed: {
    round: ({ flip }) => (flip ? 'round-right' : 'round-left'),
  },
  mixins: [toothMixin],
  name: 'ToothDown5',
  props: {
    isMilky: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.tooth {
  flex-direction: column-reverse;
}
.tooth__body {
  grid-template-rows: 30px 25px 66px;
}
.tooth__parts {
  top: auto;
  bottom: 17.28px;
}
.tooth__body__bone.round-left {
  border-radius: 0 0 0 20px;
}
.tooth__body__bone.round-right {
  border-radius: 0 0 20px 0;
}
.tooth__body__gingiva.round-left {
  border-radius: 10px 0 0 0;
}
.tooth__body__gingiva.round-right {
  border-radius: 0 10px 0 0;
}
</style>
